import { render, staticRenderFns } from "./OwnerNewAccessCode.vue?vue&type=template&id=3f881490&"
import script from "./OwnerNewAccessCode.vue?vue&type=script&lang=ts&"
export * from "./OwnerNewAccessCode.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerNewAccessCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports